<div class="patient-details-container">
  <h2 class="titleBar">{{ "Patient Information" | translate }}</h2>

  <div class="personal-info">
    <div class="form-row">
      @if (patient?.firstName || patient?.lastName) {
        <div class="info-item">
          <label>{{ "Fullname:" | translate }}</label>
          <span>{{ patient?.firstName }} {{ patient?.lastName }}</span>
        </div>
      }
      @if (patient?.dateOfBirth) {
        <div class="info-item">
          <label>{{ "Date of Birth:" | translate }}</label>
          <span>{{ patient?.dateOfBirth }}</span>
        </div>
      }
    </div>

    <div class="form-row">
      @if (patient?.email) {
        <div class="info-item">
          <label>{{ "Email:" | translate }}</label>
          <span>{{ patient?.email }}</span>
        </div>
      }
      @if (patient?.phone) {
        <div class="info-item">
          <label>{{ "Phone Number:" | translate }}</label>
          <span>{{ patient?.phone }}</span>
        </div>
      }
    </div>

    <div class="form-row">
      @if (patient?.gender) {
        <div class="info-item">
          <label>{{ "Gender:" | translate }}</label>
          <span>{{ patient?.gender }}</span>
        </div>
      }
      @if (patient?.bloodType) {
        <div class="info-item">
          <label>{{ "Blood Type:" | translate }}</label>
          <span>{{ patient?.bloodType }}</span>
        </div>
      }
    </div>

    <div class="form-row">
      @if (patient?.height) {
        <div class="info-item">
          <label>{{ "Height:" | translate }}</label>
          <span>{{ patient?.height }} cm</span>
        </div>
      }
      @if (patient?.weight) {
        <div class="info-item">
          <label>{{ "Weight:" | translate }}</label>
          <span>{{ patient?.weight }} kg</span>
        </div>
      }
    </div>

    <!-- List of Assigned Doctors -->
    @if (patient?.assignedDoctors?.length) {
      <div class="form-row">
        <div class="info-item">
          <label>{{ "Assigned Doctors:" | translate }}</label>
          <div>
            <!-- Display the primary doctor first -->
            @if (getPrimaryDoctor(); as primaryDoctor) {
              <div>
                {{ primaryDoctor.doctorFullName }} (Primary)
              </div>
            }
            <!-- Display the rest of the assigned doctors -->
            @for (doctor of getNonPrimaryDoctors(); track doctor) {
              <div>
                {{ doctor.doctorFullName }}
              </div>
            }
          </div>
        </div>
      </div>
    }

    @if (patient?.documentDto) {
      <div>
        @for (document of patient?.documentDto; track document) {
          <div>
            <div class="form-row" style="padding-top: 20px">
              <div class="info-item">
                <label>{{ "Document Type:" | translate }}</label>
                <span>{{ document?.documentType }}</span>
              </div>
            </div>
            <div class="form-row">
              <div class="info-item">
                <label>{{ "Document Number:" | translate }}</label>
                <span>{{ document?.documentNumber }}</span>
              </div>
            </div>
            <div class="form-row">
              <div class="info-item">
                <label>{{ "Document Country:" | translate }}</label>
                <span>{{ document?.documentCountryIssued }}</span>
              </div>
            </div>
          </div>
        }
      </div>
    }
    @if (!patient?.documentDto) {
      <div>
        <p>{{ "No documentation available for this patient." | translate }}</p>
      </div>
    }
  </div>

  <div class="address-info">
    <h3 class="infoBar">{{ "Address Information" | translate }}</h3>
    <div class="form-row">
      @if (patient?.addressStreet) {
        <div class="info-item">
          <label>Street:</label>
          <span>{{ patient?.addressStreet }}</span>
        </div>
      }

      @if (patient?.addressDistrict) {
        <div class="info-item">
          <label>District:</label>
          <span>{{ patient?.addressDistrict }}</span>
        </div>
      }
    </div>

    <div class="form-row">
      @if (patient?.addressStreetNumber) {
        <div class="info-item">
          <label>Street Number:</label>
          <span>{{ patient?.addressStreetNumber }}</span>
        </div>
      }

      @if (patient?.addressApartmentNumber) {
        <div class="info-item">
          <label>Apartment Number:</label>
          <span>{{ patient?.addressApartmentNumber }}</span>
        </div>
      }
    </div>

    <div class="form-row">
      @if (patient?.addressTown) {
        <div class="info-item">
          <label>Town:</label>
          <span>{{ patient?.addressTown }}</span>
        </div>
      }
      @if (patient?.addressPostCode) {
        <div class="info-item">
          <label>Post Code:</label>
          <span>{{ patient?.addressPostCode }}</span>
        </div>
      }
    </div>

    <div class="form-row">
      @if (patient?.addressCountry) {
        <div class="info-item">
          <label>Country:</label>
          <span>{{ patient?.addressCountry }}</span>
        </div>
      }
    </div>
  </div>
</div>
